import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { ImmoTaskEditable } from '../get-immo-task-for-edit/immo-task-for-edit';
import { Observable } from 'rxjs';
import {
  DeserializeVoid,
  _post,
  _put,
} from '../../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class CreateEditImmoTaskControllerRequestService {
  private readonly post: <T>(
    path: string,
    body: ImmoTaskEditable,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly put: <T>(
    path: string,
    body: ImmoTaskEditable,
    deserialize: (response: any) => T
  ) => Observable<T>;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post('/immotask', requestServices);
    this.put = _put('/immotask', requestServices);
  }

  public createEditTask(task: ImmoTaskEditable): Promise<void> {
    return task.id == null
      ? this.post('/create', task, DeserializeVoid).toPromise()
      : this.put('/update', task, DeserializeVoid).toPromise();
  }
}
